// extracted by mini-css-extract-plugin
export default {"main":"Home_main__NRABM","Home":"Home_Home__VRJNa","ovarlay":"Home_ovarlay__F5zZ0","caption":"Home_caption__y4SSH"};